import { forwardRef, useState } from 'react'

import { AuthPasswordToggle } from '@/components/auth/AuthPasswordToggle'
import { authFieldClassName } from '@/components/auth/authStyles'
import { Input } from '@/components/ui/input'
import { cn } from '@/lib/utils'

export const PasswordInput = forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  function PasswordInputRef({ className, ...props }, ref) {
    const [showPassword, setShowPassword] = useState(false)

    return (
      <div className="relative">
        <Input
          ref={ref}
          type={showPassword ? 'text' : 'password'}
          className={cn(authFieldClassName, 'pr-12', className)}
          {...props}
        />

        <AuthPasswordToggle
          showPassword={showPassword}
          onToggle={() => setShowPassword((value) => !value)}
        />
      </div>
    )
  },
)
